import { createApi } from "@reduxjs/toolkit/query/react";
import createBaseQuery from "./createBaseQuery";
export function createOutboundStreamsApi(baseUrl) {
    const outboundStreamsApi = createApi({
        reducerPath: `outboundStreamsAPI_${baseUrl}`,
        baseQuery: createBaseQuery(baseUrl),
        tagTypes: [
            "UdpStreams"
        ],
        endpoints: (build)=>({
                getUdpStreams: build.query({
                    query: ()=>({
                            url: "api/admin/stream-destinations",
                            method: "GET"
                        }),
                    providesTags: [
                        "UdpStreams"
                    ],
                    transformErrorResponse: (response)=>{
                        if (response.status === 403) {
                            return response;
                        } else if (response.data && typeof response.data === "object" && "message" in response.data) {
                            return response.data.message ?? "Failed to fetch UDP stream destinations.";
                        }
                        return "An unknown error occurred while fetching UDP stream destinations.";
                    }
                }),
                addUdpStream: build.mutation({
                    query: (payload)=>({
                            url: "api/admin/stream-destinations",
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: payload
                        }),
                    invalidatesTags: [
                        "UdpStreams"
                    ],
                    transformErrorResponse: (response)=>{
                        if (response.status === 403) {
                            return response;
                        } else if (response.data && typeof response.data === "object" && "message" in response.data) {
                            return response.data.message ?? "Failed to add UDP stream destination.";
                        }
                        return "An unknown error occurred while adding UDP stream destination.";
                    }
                }),
                removeUdpStream: build.mutation({
                    query: ({ id })=>({
                            url: `api/admin/stream-destinations/${id}`,
                            method: "DELETE"
                        }),
                    invalidatesTags: [
                        "UdpStreams"
                    ],
                    transformErrorResponse: (response)=>{
                        if (response.status === 403) {
                            return response;
                        } else if (response.data && typeof response.data === "object" && "message" in response.data) {
                            return response.data.message ?? "Failed to remove UDP stream destination.";
                        }
                        return "An unknown error occurred while removing UDP stream destination.";
                    }
                })
            })
    });
    return outboundStreamsApi;
}
